import { MapContainer, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./MapView.css";
import { useEffect, useState } from "react";

export default function MapView() {

  const [geoData, setGeoData] = useState(null);

  useEffect(() => {
    fetch("/data/gadm41_PER_1.json")
      .then(res => res.json())
      .then(data => setGeoData(data));
  }, []);

  return (
    <div className="app-container">

      {/* SIDEBAR */}
      <aside className="sidebar">
        <div>Mapa Comercial</div>
      </aside>

      <main className="main-container">

        {/* TOPBAR */}
        <header className="topbar">
          <div>ENERJET DASHBOARD</div>
        </header>

        <div className="dashboard-pane">

          <div className="pane-header">
            MAPA TERRITORIAL
          </div>

          <div className="canvas-amarillo">

            {/* AVATAR */}
            <div className="avatar-container">
              <img src="/img/avatar2.png" className="avatar-img" alt="avatar" />
            </div>

            {/* MAPA */}
            <div className="map-container">

              <div className="rayo-bg">

                <div className="map-wrapper">

                  <MapContainer
                    center={[-9.19, -75.0152]}
                    zoom={6}
                    style={{ height: "100%", width: "100%" }}
                    zoomControl={false}
                  >
                    {geoData && (
                     <GeoJSON
  data={geoData}
  style={() => ({
    color: "#000",
    fillColor: "#fff",
    weight: 1,
    fillOpacity: 1
  })}
  onEachFeature={(feature, layer) => {

    const nombre = feature.properties.NAME_1.toUpperCase();

    layer.bindTooltip(
      `<span class="dept-label">
        ⚡ ${nombre}
      </span>`,
      {
        permanent: true,
        direction: "center",
        className: "label-depto"
      }
    );

  }}
/>
                    )}
                  </MapContainer>

                </div>

              </div>

            </div>

            {/* FILTROS */}
            <div className="filters-container">

              <div className="filter-box">
                <div className="filter-header">
                  ⚡ ZONA
                </div>
                <ul className="filter-list"></ul>
              </div>

              <div className="filter-box">
                <div className="filter-header">
                  ⚡ AN
                </div>
                <ul className="filter-list"></ul>
              </div>

            </div>

          </div>

        </div>

      </main>
    </div>
  );
}